const DOT = {
    disconnected: "bg-[#52525b]",
    connected: "bg-[#10B981] shadow-[0_0_10px_rgba(16,185,129,0.6)]",
    flashing: "bg-[#3B82F6] animate-pulse shadow-[0_0_10px_rgba(59,130,246,0.6)]",
    done: "bg-[#10B981] shadow-[0_0_10px_rgba(16,185,129,0.6)]",
    error: "bg-[#ef4444] shadow-[0_0_10px_rgba(239,68,68,0.6)]",
};

const LABEL = {
    disconnected: "Disconnected",
    connected: "Device Ready",
    flashing: "Updating…",
    done: "Update Complete",
    error: "Error",
};

export const StatusBadge = ({ status }) => {
    const s = status || "disconnected";
    return (
        <div
            data-testid="status-indicator"
            className="flex items-center gap-2.5 text-xs font-mono uppercase tracking-[0.2em] text-[#ededed]"
        >
            <span className={`w-2 h-2 rounded-full ${DOT[s]}`} />
            <span>{LABEL[s]}</span>
        </div>
    );
};
